import React from 'react'
import { Card, Typography, Empty } from 'antd'
import { CalendarOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

const FollowUpTaskManager = ({ accountData, patientId }) => {
  return (
    <div>
      <Card
        size='small'
        title={
          <Title level={5} style={{ margin: 0 }}>
            Follow-up Tasks
          </Title>
        }
      >
        <Empty
          image={<CalendarOutlined style={{ fontSize: 48, color: '#d9d9d9' }} />}
          description={
            <div>
              <Text type='secondary' style={{ fontSize: 16 }}>
                Coming Soon
              </Text>
              <br />
              <Text type='secondary'>
                Task management, automated reminders, and follow-up scheduling will be available in the next release.
              </Text>
            </div>
          }
        />
      </Card>
    </div>
  )
}

export default FollowUpTaskManager
